export default __webpack_public_path__ + "static/img-system-7510cd26a6b36af2838721192e9fee00.png";